import axios from 'axios';
import { toast } from 'react-toastify';
import history from '../history';
import { saveAttemptSummary, clearAttemptSummary } from '../utils/attemptSummary';
import { FETCH_USER, GET_ACTIVE_EXAM, GET_CANDIDATE, GET_CANDIDATES, GET_CURRENT_SUBJECT, REMOVE_ERROR, SIGN_IN, SIGN_OUT, _LOADING } from './types';


export const signIn = formValues => async dispatch => {
    try {
        dispatch({ type: _LOADING, payload: true });
        const {data} = await axios.post('/api/v1/auth/login', formValues)
        clearAttemptSummary();
        dispatch({type: SIGN_IN, payload: data});
        dispatch({ type: _LOADING, payload: false });
        if (data.data.status === 'Submitted') {
            saveAttemptSummary(data.data);
            history.push(`/exams/${data.data.id}/summary`);
        } else {
            history.push("/welcome");
        }
    } catch (err) {
        toast(err.response?.data.errors[0].message, {type: toast.TYPE.DANGER, className: 'bg-danger text-white'})
        dispatch({ type: _LOADING, payload: false });
    }
};

export const signout = () => async dispatch => {
    await axios.post('/api/v1/auth/candidate_logout');
    clearAttemptSummary();
    localStorage.removeItem('currentSubject');
    localStorage.removeItem('request');
    localStorage.removeItem('timeSpent');
    localStorage.removeItem('timeLeft');
    localStorage.removeItem('shouldCount');
    localStorage.removeItem('totalAttempted');
    dispatch({ type: SIGN_OUT});
    history.push('/');
}

export const clearError = () => {
    return { type: REMOVE_ERROR}
}

export const fetchUser = () => async dispatch => {
    try {
        const {data} = await axios.get('/api/v1/auth/currentCandidate');
        // console.log({...data, data: {...data.data, currentSubject: JSON.parse(localStorage.getItem('currentSubject'))}});
        // dispatch({ type: FETCH_USER, payload: data });
        dispatch({ type: FETCH_USER, payload:  {...data, data: {...data.data, currentSubject: JSON.parse(localStorage.getItem('currentSubject'))}}  });
    } catch (err) {
        if (err.response?.status === 401) {
            history.push('/');
            dispatch({type: SIGN_OUT})
        }
        // Dispatch error action
    }
};

export const updateMe = candidate => {
    return { type: FETCH_USER, payload: {data: candidate}}
}

export const startMyExam = id => async dispatch => {
    try {
        dispatch({ type: _LOADING, payload: true});
        const {data} = await axios.put(`/api/v1/candidates/${id}/start_exam`, {id});
        clearAttemptSummary();
        ['request', 'timeSpent', 'timeLeft', 'shouldCount', 'totalAttempted'].forEach(key => localStorage.removeItem(key));
        localStorage.setItem('currentSubject', JSON.stringify(data.data.currentSubject || data.data.subjects[0]));
        dispatch({type: FETCH_USER, payload: data });
        dispatch({ type: _LOADING, payload: false});
        history.push(`/exams/${id}`);
    } catch (err) {
        if (err.response.status === 401) {
            dispatch({type: SIGN_OUT})
            history.push('/');
        }
        toast(err.response?.data.errors[0].message, {type: toast.TYPE.DANGER, className: 'bg-danger text-white'});
        dispatch({ type: _LOADING, payload: false});
    }
}

// Keep the grading response and show the completed attempt summary.
export const endMyExam = (id, timeSpent) => async dispatch => {
    try {
        dispatch({ type: _LOADING, payload: true});
        const responses = JSON.parse(localStorage.getItem('request') || '{}');
        if (responses && Object.keys(responses).length) {
            await axios.put(`/api/v1/candidates/${id}/response`, { responses, timeSpent, waitForCompletion: true });
            localStorage.setItem('request', '{}');
        }
        const {data} = await axios.put(`/api/v1/candidates/${id}/end_exam`, {candidate: id, timeSpent});
        saveAttemptSummary(data.data);
        // Leave the exam screen before clearing the subject used by its menu.
        // Summary can render immediately from the saved grading response.
        history.push(`/exams/${id}/summary`);
        localStorage.removeItem('currentSubject');
        dispatch({type: FETCH_USER, payload: data});
        dispatch({ type: _LOADING, payload: false});
        toast('Your attempts have been submitted, thank you', {type: toast.TYPE.SUCCESS, className: 'bg-success text-white'})
    } catch (err) {
        if (err.response?.status === 401) {
            dispatch({ type: _LOADING, payload: false});
            dispatch({type: SIGN_OUT})
            history.push('/');
            return;
        }
        dispatch({ type: _LOADING, payload: false});
        toast(err.response?.data?.errors?.[0]?.message || 'Your exam could not be submitted. Please try again.', {type: toast.TYPE.ERROR});
    }
}

export const getMyExam = id => async dispatch => {
    const { data } = await axios.get(`/api/v1/candidates/${id}/my_exam`);
    dispatch({ type: GET_CANDIDATE, payload: data })
};

export const saveChoice = (candidate, payload) => async dispatch => {
    await axios.put(`/api/v1/candidates/${candidate}/response`, payload);
    // dispatch({ type: FETCH_USER, payload: data });
};

export const switchSubject = (subjectName, candidateId) => async dispatch => {
    const {data} = await axios.put(`/api/v1/candidates/${candidateId}`, {currentSubject: subjectName})
    dispatch({ type: FETCH_USER, payload: data });
}

export const changeSubject = candidate => {
    // return{ type: SET_CURRENT_SUBJECT, payload: subject };
    return { type: FETCH_USER, payload: {data: candidate}}
}

export const getChangeSubject = () => {
    return{ type: GET_CURRENT_SUBJECT };
}


/**EXAM */
export const getActiveExam = id => async dispatch => {
    const {data} = await axios.get(`/api/v1/exams/active/${id}`);
    dispatch({type: GET_ACTIVE_EXAM, payload: data });
}

/**CANDIDATE */

export const fetchCandidate = () => async dispatch => {
    try {
        const {data} = await axios.get('/api/v1/auth/currentCandidate');
        dispatch({ type: GET_CANDIDATE, payload: data });
    } catch (err) {
        if (err.response.status === 401) {
            history.push('/');
            dispatch({type: SIGN_OUT})
        }
        // Dispatch error action
    }
};

export const getExamCandidates = (examId) => async dispatch => {
    try {
        const {data} = await axios.get(`/api/v1/exams/${examId}/candidates`);
        dispatch({ type: GET_CANDIDATES, payload: data })
    } catch (err) {
        if (err.response.status === 401) {
            history.push('/admin');
            dispatch({type: SIGN_OUT})
        }
        // Dispatch error action
    }
}

export const getCandidate = id => async dispatch => {
    const {data} = await axios.get(`/api/v1/candidates/${id}`);
    dispatch({type: GET_CANDIDATE, payload: data });
}
